import { useMemo } from 'react';
import { DatePickerInputValue, FormatterStyle, SelectionType } from '../types';
import { formatDate } from '../utils';

type UseFormatProps = {
  value?: DatePickerInputValue;
  format: FormatterStyle;
  locale?: string;
  selectionType?: SelectionType;
};

export default function useFormatDate({
  value,
  format,
  locale,
  selectionType,
}: UseFormatProps) {
  return useMemo(() => {
    if (!value) return '';
    if (selectionType === 'single' && !Array.isArray(value))
      return formatDate(value, format, locale);

    if (Array.isArray(value) && value.length > 0) {
      const formattedRange = value.map((date) =>
        formatDate(date, format, locale),
      );
      return formattedRange.join(' - ');
    }
    return '';
  }, [value, format, locale, selectionType]);
}
